import { render, staticRenderFns } from "./hcTest.vue?vue&type=template&id=e806b572&scoped=true&"
import script from "./hcTest.vue?vue&type=script&lang=js&"
export * from "./hcTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e806b572",
  null
  
)

export default component.exports